// Use absolute path to BE if both be and fe are deployed locally (example http://localhost:3000)
export const basicConfig = {
  gridFitApi: '',
};
